import { service } from 'Services/api/api.service';
import { TAX_YEAR } from 'Config';
import { SatServiceType } from './types';

const BASE_ENDPOINT_URL = 'sat';

const SatService: SatServiceType = {
  getSatUser: params => service.get(`${BASE_ENDPOINT_URL}/user`, { params }),
  saveSatUser: data => service.post(`${BASE_ENDPOINT_URL}/user`, data),
  saveEfirmaUser: data => service.patch(`${BASE_ENDPOINT_URL}/user/efirma`, data),
  saveSatPasswordUser: data => service.patch(`${BASE_ENDPOINT_URL}/userUpdatePassword`, data),
  retrySatUser: () => service.post(`${BASE_ENDPOINT_URL}/data`),
  getPueblaPreviousYears: () => service.get(`/records-archive/summary`),
  getReintents: () => service.get(`/tax-data?taxYear=${TAX_YEAR}`),
};

export default SatService;
